import React, { Component } from 'react';
import axios from 'axios'
import { toCurrency, serverIp, firebaseAuth, PAYMENT_TYPE_STOCK } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants';
import { StockPaymentTable } from './StockPaymentTable';
import GroupPayment from './GroupPayment';
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';


class StockPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: '',
            user: '',
            itemArray: [],
            grandTotal: 0
            //loading:true,
        }
    }


    componentDidMount() {
        console.log("++++++++: componentDidMount");
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            if (user) {
                console.log("mdx1 user exists..");
                // let isAnonymous = user.isAnonymous;
                let uid = user.uid;
                console.log("mdx12 uid:" + uid)
                console.log("mdx121 uid:" + user.email)

                if (user) {
                    console.log("maddx241 user is:" + user.email);

                    if (user.email) {
                        console.log("addx290 user.email  is:" + user.email);
                        this.setState({
                            user: user
                        })

                        //CHECK ALGOLIA FOR USER
                        checkAdminEmail(user.email, this.setAdminResult)
                    }

                } else {
                    console.log("rlx121 user NOT found");
                    this.setState({
                        authed: false,
                        // loading: false,
                        user: user,
                        uid: user.uid
                    })
                }

                //  this.setState({ admin: true, loading: false });

                // this.checkForUserInUserNode(user.uid);

            } else {
                console.log("px13 user DOES NOT exist..");
                this.setState({
                    authed: false,
                    loading: false
                })
            }
        })
        this.getDeliveredStockPayments();

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
      //  console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            isAdmin: returnObject.isAdmin,
        })
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    getDeliveredStockPayments = () => {
        console.log("cpx1 ======getDeliveredStockPayments");

        this.setState({ loading: true })

        axios.post(serverIp + 'stockPayment/fetchUnpaidDeliveredStockOrders', {
            apiKey: "PrintB@da7"
        })
            .then((response) => {
                this.setState({ loading: false });

                console.log(JSON.stringify(response.data, null, 3));

                this.setState({
                    orders: response.data.indyOrders,
                    itemArray: response.data.itemArray,
                    grandTotal: response.data.unPaidStockItemsTotal.totalAmount
                });

                if (response.data.result) {
                    console.log("true.. setting coupon");

                } else {
                    console.log("FAILED");
                    alert("FAILED!!! TO add back:" + response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("failed to get records");
                this.setState({
                    loading: false
                })
            });
    }



    render() {

        const itemTotals = this.state.itemArray.length > 0
            ? this.state.itemArray.map((item) => <GroupPayment item={item} user={this.state.user} paymentType={PAYMENT_TYPE_STOCK} />)
            : ''

        const orderTableStock = this.state.orders.length > 0
            ? <StockPaymentTable
                orders={this.state.orders}
                reloadOrders={this.getDeliveredStockPayments}
                user={this.state.user} />
            : ""

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'


        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.stockPayment
            ? <div>

                <h3>TOTAL:{toCurrency(this.state.grandTotal)}</h3>
                <br />
                {itemTotals}
                {orderTableStock}

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :

                <div>
                    <h1>DELIVERED STOCK ORDERS:{this.state.orders.length}</h1>
                    {wholeUI}
                </div>
        )
    }
}

export default StockPayment;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/StockPayment.js